
import React, { Component } from 'react'
import { Stepper, GetInfo } from '@operations/shared';
import AssignUserRoleForm from './assignUserRoleForm';
import { getUserByPhoneApi } from '../../utils/apisConsts';

class AssignUserRoles extends Component{
    state = {
        componentSteps: [
            {
                title: 'Get User',
                content: <GetInfo apiLink={getUserByPhoneApi} />,
                id: 0,
            }, {
                title: 'Assign User Roles',
                content: <AssignUserRoleForm />,
                id: 1
            },
        ]
    }

    render() {
        const { componentSteps } = this.state;
        return (
            <>
                <Stepper componentSteps={componentSteps} />
            </>
        )
    }
}

export default AssignUserRoles
